import { Link } from 'react-router-dom';
import Mock from 'assets/images/mock.png';
import Like from 'assets/images/svg/like.svg';
import LikeGrey from 'assets/images/svg/like-grey.svg';
import { useAuthState } from 'context';

export const VotesCardBig = ({ news }) => {
	const { userDetails } = useAuthState();

	const image =
		news.images && news.images?.length > 0 ? news.images[0].path : Mock;
	const prepTitle =
		news.organization_name.length > 60
			? news.organization_name.substring(0, 60) + '...'
			: news.organization_name;

	return (
		<div className='news__item'>
			<Link to={`/voting/${news.id}`} className='new new_big'>
				<div className='new__img-block'>
					<img src={image} alt='' width='544' height='225' loading='lazy' />
				</div>
				<div className='new__text-block'>
					<p className='new__text'>{prepTitle}</p>
					<span className='new__date'>
						<img src={userDetails.voteable_id === news.id ? Like : LikeGrey} alt='' />
						{news.votes_count}
					</span>
				</div>
			</Link>
		</div>
	);
};
